import { IAjax } from 'lib/Ajax';
import { CachedModelLoader } from 'lib/CachedModelLoader';

import { PCCache } from 'data/PCCache';

import { BerthAmenityType, BerthAmenityTypeOptions } from 'data/models/BerthAmenityType';
import { Organization, OrganizationOptions } from 'data/models/Organization';

import { OrderableLookups, OrderableLookupsParams } from 'portcall/orderablelookups/model';

export interface AmenityListMgmtParams {
    id : number;
}

export function AmenityListMgmt(
    loader : CachedModelLoader<Organization, OrganizationOptions>,
    ajax : IAjax,
    data : PCCache,
    orderableLookupsModel : (params : OrderableLookupsParams<BerthAmenityType, BerthAmenityTypeOptions>) => OrderableLookups<BerthAmenityType>,
    { id } : AmenityListMgmtParams
) {
    const { model } = loader({ Id: id }, 30),
        orderableLookups = orderableLookupsModel({
            supportsAdd: true,
            addClient: ajax.Url<BerthAmenityType, BerthAmenityTypeOptions>(() => model.BerthAmenityTypesUrl() || ''),
            items: model.BerthAmenityTypes.filter(a => a.Active()),
            cacheCollection: data.BerthAmenityTypes,
            orderProp: a => a.Order,
            itemFactory: order => new BerthAmenityType({
                Id: 0,
                Active: true,
                Name: '--',
                Order: order
            }),
            itemKey: a => a.Id(),
            deleteFn: (client, draft) => draft.Active(false)
        });

    return {
        Model: model,
        OrderableLookups: orderableLookups
    };
}
export type AmenityListMgmt = ReturnType<typeof AmenityListMgmt>;


// WEBPACK FOOTER //
// ./apps/portcall/amenitylistmgmt/model.ts